var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("h1", { staticClass: "form-title" }, [_vm._v("Syllabus Draft")]),
      _c("p", { staticClass: "text mt-30" }, [
        _vm._v(
          " A template (below) has been provided for your convenience when formatting your seminar outline. Please create a copy of the document and replace all the highlighted fields with relevant information pertaining to your seminar. When finished, please upload an editable document to the Portal. "
        )
      ]),
      _c(
        "Button",
        {
          staticClass: "btn-download mt-20",
          attrs: { skin: "grey" },
          on: { click: _vm.handleClickDownload }
        },
        [_vm._v("Syllabus Template")]
      ),
      _c("p", { staticClass: "text mt-20" }, [
        _vm._v("Please upload your syllabus draft here and click submit")
      ]),
      _c("FileUploader", {
        staticClass: "mt-20 inp-wrap big",
        attrs: {
          text: "Upload",
          acceptType: ["DOC", "DOCX", "PAGES"],
          value: _vm.value.file,
          loadText: "loading",
          role: _vm.ROLES.SL
        },
        on: {
          input: function($event) {
            return _vm.handleInput($event, "file")
          }
        }
      }),
      _c(
        "Button",
        { staticClass: "btn-submit", on: { click: _vm.handleClickSubmit } },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }